import { Shield, Users, Truck, Clock, DollarSign, MapPin, HeartHandshake, Camera, PackageCheck, Recycle, Zap } from "lucide-react";
import ServicePageLayout from "@/components/ServicePageLayout";
import NotFound from "@/pages/NotFound";
import { getSuburb } from "@/content/suburbs";

const SuburbPage = ({ slug }: { slug: string }) => {
  const suburb = getSuburb(slug);
  if (!suburb) return <NotFound />;

  const isCommercial = suburb.kind === "commercial";

  return (
    <ServicePageLayout
      slug={suburb.slug}
      title={suburb.metaTitle}
      metaDescription={suburb.metaDescription}
      h1={isCommercial ? `Rubbish Removal ${suburb.name}` : `Rubbish Removal ${suburb.name}`}
      subtitle={suburb.subtitle}
      breadcrumbLabel={suburb.name}
      breadcrumbParent={{ label: "Locations", href: "/locations" }}
      schemaServiceType="Rubbish Removal Services"
      areaServed={[suburb.name, "Melbourne"]}
      aboutHeading={`Rubbish Removal in ${suburb.name}`}
      overview={suburb.overview}
      includedHeading={`Included on Every ${suburb.name} Job`}
      included={[
        { icon: Users, label: "Friendly Local Crew" },
        { icon: Truck, label: "All Loading Done For You" },
        { icon: PackageCheck, label: "Careful Removal" },
        { icon: DollarSign, label: "Upfront Pricing" },
        { icon: Camera, label: "Easy Photo Quotes" },
        { icon: Recycle, label: "Responsible Disposal" },
        { icon: Clock, label: "Fast Pickup Windows" },
        { icon: Shield, label: "Fully Insured" },
      ]}
      whyUsHeading={`Why Choose OZ WASTE CO. in ${suburb.name}`}
      whyUs={[
        { icon: MapPin, title: "Melbourne Owned", desc: "A local rubbish removal team, not an interstate call centre or franchise." },
        { icon: DollarSign, title: "Upfront Quotes", desc: "Know the agreed price before the job begins, no surprises." },
        { icon: Truck, title: "We Do the Lifting", desc: "No dragging everything outside or loading a skip yourself." },
        { icon: Camera, title: "Photo Quotes", desc: "Send a few photos so we can assess the job quickly." },
        { icon: Zap, title: "Fast Pickup", desc: "Same-day and short-notice pickups available depending on the schedule." },
        { icon: Recycle, title: "Responsible Disposal", desc: "Reusable and recyclable items are diverted from landfill where possible." },
        { icon: Clock, title: "Reliable Timing", desc: "Realistic pickup windows we actually stick to." },
        { icon: HeartHandshake, title: "Friendly Service", desc: "Calm, tidy and respectful from first call to final sweep." },
      ]}
      faqs={suburb.faqs}
    />
  );
};

export default SuburbPage;
